module.exports = __webpack_public_path__ + "static/HSE_ESG_Report_2023_engl-380cb8a0e596c76c67a08b05019a7b25.pdf";